$(document).ready(function() {

	// TAB COLLECTION SLIDER

	const indicator = document.querySelector(".nav-indicator");
	const items = document.querySelectorAll(".nav-item");

	function handleIndicator(el) {
		items.forEach((item) => {
			item.classList.remove("is-active");
			item.removeAttribute("style");
		});

		indicator.style.width = `${el.offsetWidth}px`;
		indicator.style.left = `${el.offsetLeft}px`;
		indicator.style.backgroundColor = el.getAttribute("active-color");

		el.classList.add("is-active");
		el.style.color = el.getAttribute("active-color");
	}

	items.forEach((item, index) => {
		item.addEventListener("click", (e) => {
			handleIndicator(e.target);
		});
		item.classList.contains("is-active") && handleIndicator(item);
	});

	$('.tab_collections_slider').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrow: false,
				centerMode: true,
				centerPadding: '150px'
			}
		}]
	});

	$('.nav-item').click(function(e) {
		e.preventDefault();
		var df = $(this).attr('data-for');
		$('.tab_collections_slider').slick('slickUnfilter');
		$('.tab_collections_slider').slick('slickFilter', '.' + df);
	});

	// VIEW BUTTON JS
	$('.nav-item-view-all').click(function(e) {
		e.preventDefault();
		var df = $(this).attr('data-for');

		$('.view-all-box-slider').hide();
		$('.view-all-box-slider.' + df).show();
	});
	// END VIEW BUTTON JS


	// END TAB COLLECTION SLIDER




	// TAB COLLECTION GRID
	const indicatorPro = document.querySelector(".nav-indicator-pro");
	const itemsPro = document.querySelectorAll(".nav-item-pro");

	function handleIndicatorPro(el) {
		itemsPro.forEach((item) => {
			item.classList.remove("is-active");
			item.removeAttribute("style");
		});

		indicatorPro.style.width = `${el.offsetWidth}px`;
		indicatorPro.style.left = `${el.offsetLeft}px`;
		indicatorPro.style.backgroundColor = el.getAttribute("active-color");

		el.classList.add("is-active");
		el.style.color = el.getAttribute("active-color");
	}

	itemsPro.forEach((item, index) => {
		item.addEventListener("click", (e) => {
			handleIndicatorPro(e.target);
		});
		item.classList.contains("is-active") && handleIndicatorPro(item);
	});

	$('.nav-item-pro').click(function(e) {
		e.preventDefault();
		var df = $(this).attr('data-for');
		$('.tab-collection-grid').hide();
		$('.tab-collection-grid.' + df).show();

		$('.tab-collection-grid.' + df).find('.pro-collection-gallery').each(function() {
			if ($(this).hasClass('slick-initialized')) {
				$(this).slick('unslick');
			}

			$(this).slick({
				dots: true,
				infinite: false,
				speed: 200,
				cssEase: 'linear',
				arrows: false,
			});

		});

	});
	// END TAB COLLECTION GRID


	// FOR COLLECTION GALLERY
	var sliderInterval = setInterval(function() {

		$('.pgi-default-slider').on('init', function(event, slick) {
			let $dots = $(this).find('.slick-dots li');
			if ($dots.length > 4) {
				$dots.slice(4).remove();
			}
		});

		$('.pro-collection-gallery').each(function() {
			if ($(this).hasClass('slick-initialized')) {

			} else {
				$('.pro-collection-load-reduce').show();
				$(this).slick({
					dots: true,
					infinite: false,
					speed: 200,
					cssEase: 'linear',
					arrows: false
				});
			}
		});
		if (jQuery('.video-collection-enabled').length > 0) {
			$('.pro-collection-gallery').hide();
			$('.pro-collection-gallery.pro-collection-gallery-video').show();
			$('.pro-collection-gallery.pro-collection-gallery-video').slick('refresh');
			clearInterval(sliderInterval);
		}
		$("#nudge-offer-158786").addClass("appear-animation appear-delay-4");

	}, 1000);
	// END COLLECTION GALLERY


	$(document).on("click", ".color-swatch-ci", function() {
		let $swatch = $(this);
		let varId = $swatch.data("variant-id");
		let variantImage = $swatch.data("variant-image");
		let prodId = $swatch.data("pid");

		if (!prodId || !varId) {
			return;
		}

		// Find the product grid container
		let gridProduct = $('[data-product-id="' + prodId + '"]');

		if (!gridProduct.length) {
			return;
		}

		// Find all gallery containers within this product
		let galleries = gridProduct.find('.pgi-default-slider.pro-collection-gallery');

		if (galleries.length === 0) {
			// Fallback for old gallery structure
			galleries = gridProduct.find('.pro-collection-gallery-' + prodId);
		}

		galleries.each(function() {
			let $gallery = $(this);

			if (variantImage) {
				// Get the CURRENTLY VISIBLE/ACTIVE image
				let $activeSlide = $gallery.find('.slick-current .pro-collection-gallery-item');
				let $firstImage = $activeSlide.find('img').first();

				if ($firstImage.length > 0) {
					$firstImage.fadeOut(200, function() {
						$(this).fadeIn(200);
						$(this).attr('data-src', variantImage);
						$(this).attr('src', variantImage);
						$(this).removeClass('lazyloaded');
					});
				}
			}
		});
	});


	// FOR ADD TO CART
	function myFunction(id) {
		$(".dropdown-content").removeClass("show");
		document.getElementById(id).classList.toggle("show");
	}

	window.onclick = function(event) {
			if (!event.target.matches('.dropbtn')) {
				var dropdowns = document.getElementsByClassName("dropdown-content");
				var i;
				for (i = 0; i < dropdowns.length; i++) {
					var openDropdown = dropdowns[i];
					if (openDropdown.classList.contains('show')) {
						openDropdown.classList.remove('show');
					}
				}
			}
		}
		// END ADD TO CART



});
jQuery(document).on("click", ".pswp__button--close", function() {
	setTimeout(function() {
		jQuery('.pswp--css_animation').removeClass('pswp--open');
		jQuery('.pswp--css_animation').attr('aria-hidden', false);
	}, 700);
});
jQuery('body').click(function() {
	if (!$(event.target).closest('.magnify-button').length && !$(event.target).closest('.pswp__button--arrow--left').length && !$(event.target).closest('.pswp__button--arrow--right').length && !$(event.target).closest('.pswp__item').length) {
		if (jQuery('.pswp--css_animation').hasClass("pswp--open")) {
			setTimeout(function() {
				jQuery('.pswp--css_animation').removeClass('pswp--open');
				jQuery('.pswp--css_animation').attr('aria-hidden', false);
			}, 800);
		}
	}
});
/*jQuery(document).on('click','.pswp__button--arrow--right',function(){
  $('.pswp__zoom-wrap').removeAttr('style');
  $('.pswp__zoom-wrap').css({
      'transform-origin': 'center center',
      'transform': 'scale(1)' // Adjust the scale as necessary
  });
});
jQuery(document).on('click','.pswp__button--arrow--left',function(){
  $('.pswp__zoom-wrap').removeAttr('style');
    $('.pswp__zoom-wrap').css({
      'transform-origin': 'center center',
      'transform': 'scale(1)' // Adjust the scale as necessary
  });
});
jQuery(document).on('click','.magnify-button',function(){
  setTimeout(function(){
    $('.pswp__zoom-wrap').css('transform','');
      $('.pswp__zoom-wrap').css({
        'transform-origin': 'center center',
        'transform': 'scale(1)'
    });
  },100);
});*/



// PRODUCT SIZE -- START
// jQuery(document).ready(function(){
//   jQuery(".size-guide-cta").on("click",function () {
//     $("body").addClass("size_popup_active");
//   });
//   jQuery(".modal-size-content .modal__close").on("click",function () {
//     $("body").removeClass("size_popup_active");
//   });
// });

jQuery(document).ready(function() {
	jQuery(".size-guide-cta").on("click", function() {
		jQuery("body").addClass("size_popup_active");
	});

	jQuery(".modal-size-content .modal__close").on("click", function() {
		jQuery("body").removeClass("size_popup_active");
	});

	jQuery(".modal-product-size").on("click", function(e) {
		if (!jQuery(e.target).closest(".modal-content").length) {
			jQuery("body").removeClass("size_popup_active");
		}
	});
});

// PRODUCT SIZE -- END
